<template>
  <div class="users-table-container">

    <!-- ========== ENCABEZADO DE TABLA ========== -->
    <table class="users-table">
      <thead>
        <tr>
          <th>Usuario</th>
          <th>Rol</th>
          <th>Estado</th>
          <th>Acciones</th>
        </tr>
      </thead>

      <!-- ========== CUERPO DE TABLA ========== -->
      <tbody>

        <!-- ========== MENSAJE SI NO HAY USUARIOS ========== -->
        <tr v-if="users.length === 0">
          <td colspan="4" class="no-data">No hay usuarios disponibles</td>
        </tr>

        <!-- ========== FILAS DE USUARIOS ========== -->
        <tr v-for="user in users" :key="user.id">
          <td class="cell-name">
            <div class="username-container">
              <!-- Indicar si el usuario es el actual -->
              <span v-if="user.id === currentUserId" class="current-user-tag">[TU]</span>
              {{ user.username }}
            </div>
          </td>

          <td>{{ user.role }}</td>

          <td>
            <!-- Estado del usuario -->
            <span :class="['status-badge', user.is_online ? 'active' : 'inactive']">
              {{ user.is_online ? 'Conectado' : 'Desconectado' }}
            </span>
          </td>

          <td class="cell-actions">
            <!-- Botón Editar -->
            <button
              :disabled="user.id === currentUserId || user.is_online"
              class="icon-btn edit"
              @click="$emit('edit', user)"
            >
              <ion-icon name="create-outline" />
            </button>

            <!-- Botón Eliminar -->
            <button
              :disabled="user.id === currentUserId || user.is_online"
              class="icon-btn delete"
              @click="$emit('delete', user)"
            >
              <ion-icon name="trash-outline" />
            </button>

            <!-- Botón Vincular líneas -->
            <button class="icon-btn link" @click="$emit('link-lines', user)">
              <ion-icon name="link-outline" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  name: "UserTable",

  // ========== PROPIEDADES ==========
  props: {
    // Lista de usuarios a mostrar
    users: {
      type: Array,
      required: true
    },
    // ID del usuario actual (para mostrar el tag [TU])
    currentUserId: {
      type: Number,
      required: false
    }
  }
};
</script>


<style scoped>
/* ========== CONTENEDOR PRINCIPAL DE LA TABLA ========== */
.users-table-container {
  overflow-x: auto;
  border-radius: 1rem;
  border: 1px solid #e2e8f0;
  background-color: #fff;
  width: 90%;
  margin: 0 auto;
  margin-bottom: 3rem;
}

/* ========== ESTILOS BÁSICOS DE LA TABLA ========== */
.users-table {
  width: 100%;
  border-collapse: collapse;
  font-family: 'Manrope', sans-serif;
}

.users-table th {
  text-align: left;
  padding: 0.75rem 1rem;
  font-size: 0.85rem;
  font-weight: 700;
  color: #475569;
  background-color: #f1f1f1;
  border-bottom: 1px solid #e2e8f0;
}

.users-table td {
  padding: 0.85rem 1rem;
  font-size: 0.95rem;
  color: #0f172a;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: middle;
}

/* ========== CELDA DE NOMBRE DE USUARIO ========== */
.cell-name {
  font-weight: 600;
  color: #1e293b;
}

.username-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ========== CENTRAR ROL Y ESTADO ========== */
.users-table td:nth-child(2),
.users-table td:nth-child(3) {
  text-align: left;
  vertical-align: middle;
}

/* ========== ETIQUETA [TU] ========== */
.current-user-tag {
  color: #28a745;
  font-size: 12px;
  font-weight: bold;
  background: rgba(40, 167, 69, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
}

/* ========== BADGE DE ESTADO ========= */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
  font-weight: 700;
  border-radius: 9999px;
  white-space: nowrap;
  line-height: 1;
  transition: background-color 0.25s ease, color 0.25s ease;
}

.status-badge.active {
  background-color: rgba(22, 163, 74, 0.15);
  color: #16a34a;
  border: 1px solid rgba(22, 163, 74, 0.25);
}

.status-badge.inactive {
  background-color: rgba(220, 38, 38, 0.1);
  color: #dc2626;
  border: 1px solid rgba(220, 38, 38, 0.2);
}

/* ========== BOTONES DE ACCIÓN ========== */
.cell-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-start;
  align-items: center;
}

.icon-btn {
  all: unset;
  cursor: pointer;
  font-size: 1.1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.4rem;
  border-radius: 8px;
  transition: all 0.25s ease;
}

/* Botón Editar */
.icon-btn.edit {
  color: #0d9488;
  border: 1.5px solid rgba(13, 148, 136, 0.2);
  background-color: rgba(13, 148, 136, 0.05);
}

.icon-btn.edit:hover {
  background-color: rgba(13, 148, 136, 0.15);
  transform: translateY(-1px) scale(1.05);
}

/* Botón Eliminar */
.icon-btn.delete {
  color: #dc2626;
  border: 1.5px solid rgba(220, 38, 38, 0.2);
  background-color: rgba(220, 38, 38, 0.05);
}

.icon-btn.delete:hover {
  background-color: rgba(220, 38, 38, 0.15);
  transform: translateY(-1px) scale(1.05);
}

/* Botón Vincular líneas */
.icon-btn.link {
  color: #3b82f6;
  border: 1.5px solid rgba(59, 130, 246, 0.2);
  background-color: rgba(59, 130, 246, 0.05);
}

.icon-btn.link:hover {
  background-color: rgba(59, 130, 246, 0.15);
  transform: translateY(-1px) scale(1.05);
}

/* ========== BOTONES DESHABILITADOS ========== */
.icon-btn:disabled {
  cursor: not-allowed;
  transform: none;
  color: #9ca3af;
  background-color: rgba(156, 163, 175, 0.1); 
  border: 1.5px solid rgba(156, 163, 175, 0.2); 
}

.icon-btn:disabled:hover {
  background-color: rgba(156, 163, 175, 0.1);
  transform: none;
}

/* ========== MENSAJE CUANDO NO HAY DATOS ========== */
.no-data {
  text-align: center;
  padding: 2rem;
  color: #94a3b8;
  font-style: italic;
}
</style>
